import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackEvent } from '../lib/pixel';
const TIERS = [{
  id: 'base',
  badge: null,
  title: 'MegaPack Integral',
  tagline: 'Aprendé Biodescodificación',
  price: '$19.990',
  includes: ['6 tomos completos', '6 recursos prácticos', 'Casos clínicos reales', 'Protocolos completos', 'Certificado digital', 'Acceso inmediato'],
  cta: 'Quiero el MegaPack',
  href: 'https://academiaholisticaargentina.com/cart/48895855722746:1',
  accent: 'green'
}, {
  id: 'premium',
  badge: 'MÁS ELEGIDO',
  title: 'Premium',
  tagline: 'Aprendé + Consultá',
  price: '$27.990',
  includes: ['Todo lo del MegaPack Integral', 'Vademécum Interactivo', 'Herramienta rápida de consulta', 'Material complementario'],
  cta: 'Quiero el Premium',
  href: 'https://academiaholisticaargentina.com/cart/48895910347002:1',
  accent: 'gold'
}];
type Tier = (typeof TIERS)[number];
function TierCard({
  tier,
  index
}: {
  tier: Tier;
  index: number;
}) {
  const [ref, vis] = useReveal();
  const isGold = tier.accent === 'gold';
  const isDark = tier.accent === 'dark';
  const cardBg = isGold ? 'bg-[#ffffff]' : isDark ? 'bg-[#2d3f2a]' : 'bg-[#ffffff]';
  const cardBorder = isGold ? 'border-2 border-[#b8860b]/80' : isDark ? 'border-2 border-[#1e3a1e]' : 'border border-[#2d3f2a]/25';
  const shadowClass = isGold ? 'shadow-lg' : isDark ? 'shadow-xl' : 'shadow-md';
  const titleColor = isDark ? 'text-[#ffffff]' : 'text-[#1e3a1e]';
  const taglineColor = isDark ? 'text-[#eab308]' : 'text-[#3a4a35]';
  const includesLabelColor = isDark ? 'text-[#ede4d0]/90' : 'text-[#3a4a35]';
  const itemTextColor = isDark ? 'text-[#ffffff]' : 'text-[#1e3a1e]';
  const checkColor = isGold ? 'text-[#b8860b]' : isDark ? 'text-[#eab308]' : 'text-[#3a4a35]';
  const priceColor = isDark ? 'text-[#ffffff]' : 'text-[#1e3a1e]';
  const arsColor = isDark ? 'text-[#ede4d0]' : 'text-[#3a4a35]';
  const dividerColor = isGold ? 'border-[#b8860b]/30' : isDark ? 'border-[#ffffff]/20' : 'border-[#2d3f2a]/20';
  const buttonClass = isGold ? 'bg-[#eab308] hover:bg-[#d4a017] text-[#0f0f1a] shadow-[0_8px_20px_rgba(184,134,11,0.3)] hover:shadow-[0_12px_25px_rgba(184,134,11,0.4)]' : isDark ? 'bg-[#eab308] hover:bg-[#d4a017] text-[#0f0f1a] shadow-[0_8px_20px_rgba(184,134,11,0.3)]' : 'bg-[#2d3f2a] hover:bg-[#1e3a1e] text-white shadow-md hover:shadow-lg';
  const badgeBg = isGold ? 'bg-[#b8860b]' : isDark ? 'bg-[#eab308] text-[#0f0f1a]' : '';
  return <div ref={ref} id={tier.id} className={`reveal relative ${cardBg} ${cardBorder} ${shadowClass} rounded-2xl p-4 md:p-6 flex flex-col scroll-mt-[180px] md:scroll-mt-8 ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 80}ms`
  }} data-id="element-248">
      {tier.badge && <div className={`absolute -top-3 left-1/2 -translate-x-1/2 ${badgeBg} ${isDark ? '' : 'text-white'} text-[10px] font-bold tracking-[0.2em] px-4 py-1.5 rounded-full whitespace-nowrap shadow-sm`} data-id="element-249">
          {tier.badge}
        </div>}

      <h3 className={`text-base md:text-xl font-serif font-bold ${titleColor} mb-0.5 leading-tight mt-1`} data-id="element-250">
        {tier.title}
      </h3>
      <p className={`${taglineColor} text-[11px] sm:text-sm font-semibold mb-2.5 md:mb-4`} data-id="element-251">
        {tier.tagline}
      </p>

      <p className={`${includesLabelColor} text-[9px] md:text-[10px] font-bold uppercase tracking-[0.2em] mb-2`} data-id="element-252">
        Incluye:
      </p>

      <ul className="space-y-1 md:space-y-1.5 mb-3 md:mb-4 flex-grow" data-id="element-253">
        {tier.includes.map((item, i) => <li key={i} className="flex items-start gap-1.5 md:gap-2" data-id="element-254">
            <span className={`${checkColor} flex-shrink-0 mt-0.5 font-bold text-[11px] md:text-xs`} data-id="element-255">
              ✓
            </span>
            <span className={`${itemTextColor} text-[12px] md:text-[13px] leading-snug font-medium`} data-id="element-256">
              {item}
            </span>
          </li>)}
      </ul>

      <div className={`text-center mb-3 md:mb-4 pt-2.5 md:pt-3 border-t ${dividerColor}`} data-id="element-257">
        <div className="flex items-baseline gap-1.5 justify-center" data-id="element-258">
          <span className={`text-xl md:text-3xl font-extrabold ${priceColor} leading-none`} data-id="element-259">
            {tier.price}
          </span>
          <span className={`${arsColor} text-xs md:text-sm font-semibold`} data-id="element-260">
            ARS
          </span>
        </div>
      </div>

      <a href={tier.href} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
      content_name: tier.title,
      value: Number(tier.price.replace(/[^0-9]/g, '')),
      currency: 'ARS'
    })} className={`w-full block py-2.5 md:py-3 rounded-xl font-bold text-[11px] md:text-sm tracking-widest uppercase text-center transition-all hover:-translate-y-1 ${buttonClass}`} style={{
      fontFamily: "'Inter', sans-serif"
    }} data-id="element-261">
        {tier.cta} →
      </a>
    </div>;
}
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  return <section id="pricing" className="bg-[#f9f4e8] py-5 md:py-10 px-4 sm:px-6 border-t border-[#2d3f2a]/15" style={{
    scrollMarginTop: '20px'
  }} data-id="element-262">
      <div className="container mx-auto max-w-4xl" data-id="element-263">
        <div ref={ref1} className={`reveal text-center mb-5 md:mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-264">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold leading-tight text-[#1e3a1e] mb-2" data-id="element-265">
            Elegí la versión que{' '}
            <span className="text-[#b8860b] italic" data-id="element-266">mejor se adapte</span> a vos
          </h2>
          <p className="text-[#3a4a35] text-sm md:text-base max-w-2xl mx-auto leading-relaxed" data-id="element-267">
            Todas las opciones incluyen acceso inmediato y certificado digital.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5 md:gap-6 items-stretch max-w-2xl mx-auto" data-id="element-268">
          {TIERS.map((tier, i) => <TierCard key={tier.id} tier={tier} index={i} data-id="element-269" />)}
        </div>
      </div>
    </section>;
}